import { useMediaQuery, useTheme } from '@mui/material';
import { useWindowSize } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/hooks/use-window-size';
import {
  AppLayout,
  MenuPlacementType,
  SCREEN_RESIZE_MEDIA_QUERY,
} from '@monorepo/shared/src/types';

const useAppLayout = (): AppLayout => {
  const theme = useTheme();
  const isPortraitMode = useMediaQuery(SCREEN_RESIZE_MEDIA_QUERY.PORTRAIT);
  const isMinHeight = useMediaQuery(SCREEN_RESIZE_MEDIA_QUERY.MIN_HEIGHT);
  const { height: windowHeight, width: windowWidth } = useWindowSize();

  const isTopMenu = isPortraitMode || isMinHeight;

  const menuPlacement = isTopMenu ? MenuPlacementType.TOP : MenuPlacementType.ASIDE;

  const offset = {
    top: isTopMenu ? theme.constants.app.menuOffset : theme.constants.app.paddingY,
    bottom: theme.constants.app.footerOffset,
    left: isTopMenu ? theme.constants.app.paddingX : theme.constants.app.menuOffset,
    right: isTopMenu ? theme.constants.app.paddingX : theme.constants.app.menuOffset,
  };

  const containerWidth = windowWidth - (offset.left + offset.right);
  const containerHeight = windowHeight - (offset.top + offset.bottom);

  return { menuPlacement, offset, containerWidth, containerHeight, windowHeight, windowWidth };
};

export default useAppLayout;
